module.exports = __webpack_public_path__ + "static/media/calendar-star.44ef75b3.svg";